module.exports = __webpack_public_path__ + "img/AI-hover.143dd7ab.png";